import { createTheme } from '@mui/material/styles';

const themeConfig = createTheme({
    typography: {
      fontFamily: "'Lato'!important",
    },
    palette: {
      primary: {
        main: '#FFFFFF', // custom primary color
      },
      secondary: {
        main: '#000', // secondary color
      },
      background: {
        default: '#000',
      }
    },
  });

export default themeConfig;
